var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mod_logo"},[(_vm.isAmerican)?_c('div',{staticClass:"logo is_American"}):(_vm.isIflix)?_c('div',{staticClass:"logo is_iflix"}):_c('div',{staticClass:"logo normal"})])}
var staticRenderFns = []

export { render, staticRenderFns }